export default __webpack_public_path__ + "static/logo-7d7c76e11c450f07d440f19d6a8a28d6.jpeg";